import '../../node_modules/bootstrap/js/src/dropdown';
import '../../node_modules/bootstrap/js/src/collapse';
import '../../assets/scripts/remove-paragraph-from-headers';
try {
  const navLinks = document.querySelectorAll('.collapse-item');
  const navbarCollapse = document.querySelector('.navbar-collapse');
  const iconClose =document.querySelector('.icon-close');
  const iconHamburger = document.querySelector('.icon-hamburger');
  const overlay = document.querySelector('.overlay');

  navLinks.forEach((l) => {
    l.addEventListener('click', () => {
      navbarCollapse.classList?.remove('show-2');

    })
  })

  overlay.addEventListener('click', () => {
    navbarCollapse.classList?.remove('show-2');
    overlay.classList?.remove('show-2');
  })

  iconClose.addEventListener('click', () => {
    navbarCollapse.classList?.remove('show-2');
    overlay.classList?.remove('show-2');
  })

  iconHamburger.addEventListener('click', () => {
    navbarCollapse.classList?.add('show-2');
    overlay.classList?.add('show-2');

  })
} catch (e) {
  console.log(e)
}

try {
  const dropdowns = document.querySelectorAll('.menu-item-has-children');

  if(dropdowns) {
    dropdowns.forEach(elem => elem.addEventListener('click', () => {
      const childrenSubMenu = elem.querySelector('.sub-menu');
      setTimeout(() => {

        childrenSubMenu.classList.add('active');
      })
    }))
  }
  window.document.addEventListener('click', elem => {
    if (!elem.target.closest('.sub-menu.active')) {
      document.querySelectorAll('.sub-menu').forEach(elem => elem.classList.remove('active'));
    }
  })

} catch (e) {
  console.log(e)
}


try {
  const btnUp = document.querySelector('.btn-up');

  btnUp.addEventListener('click', () => {
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
  })

  const navbar = document.querySelector('.navbar');

  document.addEventListener("scroll", (e) => {
    if(document.scrollingElement.scrollTop > 0) {
      navbar.classList.add('active');
    } else {
      navbar.classList.remove('active');
    }
  });
} catch (e) {
  console.log(e)
}

try {
  const navCurrentLang = document.querySelector('.wpml-ls-current-language a');

  navCurrentLang.addEventListener('click', (e) => {
    e.preventDefault()
  })
} catch (e) {
  console.log()
}
